const github = {
  baseURL: "https://api.github.com/graphql",
  username: "gaurish-saini",
  headers: {
    "Content-Type": "application/json",
    Authorization: "bearer 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",
  },
};

export default github;